import type { CSSProperties } from 'react';

/** A router <Link> styled like the portal Button (primary / secondary). */
export const linkButtonStyle = (variant: 'primary' | 'secondary'): CSSProperties => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '2.5rem',
  padding: '0.5rem 1rem',
  borderRadius: '0.375rem',
  border: '1px solid',
  fontSize: '0.875rem',
  fontWeight: 600,
  textDecoration: 'none',
  ...(variant === 'primary'
    ? { background: '#1f4ed8', color: '#fff', borderColor: '#1e40af' }
    : { background: '#fff', color: '#111827', borderColor: '#d1d5db' }),
});
